var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#CCDBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9225 19.9225C27.9225 19.9069 27.9069 19.8912 27.9069 19.8756C27.9069 19.86 27.8912 19.8287 27.8756 19.8131C27.86 19.7975 27.8444 19.7819 27.8444 19.7662L27.7975 19.7194C27.7819 19.7037 27.7662 19.6881 27.735 19.6881L27.7037 19.6569L12.61 12.86C12.4694 12.7975 12.2975 12.8287 12.1881 12.9381C12.0787 13.0475 12.0475 13.2194 12.11 13.36L15.0631 20.0006L12.11 26.6412C12.0475 26.7819 12.0787 26.9537 12.1881 27.0631C12.2662 27.1412 12.36 27.1725 12.4537 27.1725C12.5006 27.1725 12.5631 27.1569 12.61 27.1412L27.7037 20.3444C27.7194 20.3444 27.735 20.3287 27.735 20.3131C27.7506 20.2975 27.7662 20.2975 27.7975 20.2819L27.8444 20.235C27.86 20.2194 27.8756 20.2037 27.8756 20.1881C27.8912 20.1725 27.8912 20.1412 27.9069 20.1256C27.9069 20.11 27.9225 20.0944 27.9225 20.0787V19.9225ZM13.2037 26.0475L15.7194 20.3756H25.7819L13.2037 26.0475ZM15.7194 19.6256L13.2037 13.9537L25.7975 19.6256H15.7194Z",
    fill: "#004AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCb);
export default __webpack_public_path__ + "static/media/sendCB.dc9efc382d0bba8e7c7dd6a2331e036f.svg";
export { ForwardRef as ReactComponent };